
import { Vue, Component, Prop } from 'vue-property-decorator';
import { DateTime } from 'luxon';

@Component<ScheduledOrderCard>({})
export default class ScheduledOrderCard extends Vue {
	@Prop({ type: Object, required: true }) order!: Order;

	private get formattedDate(): string[] {
		let date = DateTime.fromISO(this.order.pickup_time).setLocale(this.$i18n.locale);
		if (!date.isValid && this.order.type === 'catering') {
			date = DateTime.fromISO(this.order.data.suites!.eventStartDate).setLocale(this.$i18n.locale);
		}
		return [
			date.toFormat('EEE'),
			date.toFormat('d'),
			date.toFormat('MMM')
		];
	}

	/**
	 * Get the delivery details for the order
	 * If the order is a school order, return the student, grade, classroom, and teacher
	 * Otherwise, return the address
	 * Return 'Pickup' if no delivery details are available
	 *
	 * @return {string}
	 */
	private get deliveryDetails(): string {
		const delivery = this.order.data.checkout.delivery;
		if (delivery) {
			if (delivery.type !== 'school') {
				return this.$options.filters?.localize(delivery.address!) || delivery.address!;
			}
			return [
				`${delivery.student}`,
				`${delivery.grade ? this.$t('profile.scheduled_orders.grade', { grade: delivery.grade }) : ''}`,
				`${delivery.classroom ? this.$t('profile.scheduled_orders.class', { class: delivery.classroom }) : ''}`,
				`${delivery.teacher ? `${delivery.teacher}` : ''}`
			].filter(Boolean).join(', ');
		}

		return this.$t('profile.scheduled_orders.pickup');
	}
}
